module.exports = __webpack_public_path__ + "img/vertical_7_7_8004.6c1deac8.png";